export const offbookAdvanceTileListSelector = ({ entities }) => ({
  advances: entities.advances,
  opportunities: entities.opportunities,
});

export const offbookAdvanceTileSelector = ({ config }) => ({
  offbookMessagingEnabled: config.offbookMessagingEnabled,
});
